import { Suspense } from 'react'
import { Island } from '@/react/islands/Island'
import { MapPanel } from '@/react/map/MapPanel'
import { MenuPanel } from '@/react/chrome/MenuPanel'
import { StatBar } from '@/react/chrome/StatBar'

/** The map view. The map, stat bar and drawer are React; the island is what still draws over the map and hosts the modals. */
export function MapPage() {
  return (
    <>
      {/* The map, React since Phase 1J. BEFORE the island, so the overlays it
          still renders — the cost layer card, the legends, the widgets — paint
          above the map rather than under it. */}
      <MapPanel />
      <Suspense fallback={null}>
        <Island name="map" />
      </Suspense>
      {/* The drawer is React since Phase 1E. It portals to <body> and is
          position: fixed, so where it sits in this tree does not affect it. */}
      <MenuPanel />
      {/* The stat bar is React since Phase 1G, with the toolbar as its child
          and the cards as a Vue island inside it. position: fixed, and no
          ancestor here or in the Vue bar's old place creates a stacking
          context, so it stacks exactly as the Vue bar did. */}
      <StatBar />
    </>
  )
}
